<template>
  <div id="box">
    <div class="header-box">
      <div class="header container">
        <div class="logo">
          <img src="../../public/imgs/index/images/images/logo_03_03.png" alt="" />
        </div>
        <!---------1125------- -->
        <!-- 移动端汉堡菜单按钮 -->
        <div class="mobile-menu-btn" @click="toggleMobileMenu">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="3" y1="12" x2="21" y2="12"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <line x1="3" y1="18" x2="21" y2="18"/>
          </svg>
        </div>
        <!--  -------1125-------  -->
        <div class="nav" :class="{ 'mobile-open': showMobileMenu }">
          <ul>
            <li class="dropdown" :class="{ active: $route.path === '/' }" @mouseenter="!isMobile && (showHomeDropdown = true)" @mouseleave="!isMobile && (showHomeDropdown = false)" @click="isMobile && (showHomeDropdown = !showHomeDropdown)">
              <router-link to="/">首页
                <!-- <svg class="dropdown-arrow" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 9l6 6 6-6"/>
                </svg> -->
              </router-link>
              <transition name="dropdown">
                <!-- <ul v-show="showHomeDropdown" class="dropdown-menu">
                  <li><router-link to="/">公司介绍</router-link></li>
                </ul> -->
              </transition>
            </li>
            <li class="dropdown" :class="{ active: $route.path === '/goin' }" @mouseenter="!isMobile && (showAboutDropdown = true)" @mouseleave="!isMobile && (showAboutDropdown = false)" @click="isMobile && (showAboutDropdown = !showAboutDropdown)">
              <router-link to="/goin">走进弗鲁微科技
                <svg class="dropdown-arrow" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 9l6 6 6-6"/>
                </svg>
              </router-link>
              <transition name="dropdown">
                <ul v-show="showAboutDropdown" class="dropdown-menu">
                  <li><router-link to="/goin#intro">公司介绍</router-link></li>
                  <li><router-link to="/goin#culture">企业文化</router-link></li>
                  <li><router-link to="/goin#honor">荣誉资质</router-link></li>
                  <li><router-link to="/goin#employee">员工风采</router-link></li>
                </ul>
              </transition>
            </li>
            <li class="dropdown" :class="{ active: $route.path === '/products' }" @mouseenter="!isMobile && (showProductsDropdown = true)" @mouseleave="!isMobile && (showProductsDropdown = false)" @click="isMobile && (showProductsDropdown = !showProductsDropdown)">
              <router-link to="/products">匠心产品
                <svg class="dropdown-arrow" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 9l6 6 6-6"/>
                </svg>
              </router-link>
              <transition name="dropdown">
                <ul v-show="showProductsDropdown" class="dropdown-menu">
                  <li><router-link to="/products?tab=dynamic">动态管式反应器系列</router-link></li>
                  <li><router-link to="/products?tab=microchannel">微通道反应器系列</router-link></li>
                  <li><router-link to="/products?tab=microbubble">微气泡反应器系列</router-link></li>
                  <li><router-link to="/products?tab=mixer">微混合器系列</router-link></li>
                </ul>
              </transition>
            </li>
            <li class="dropdown" :class="{ active: $route.path === '/cases' }" @mouseenter="!isMobile && (showCasesDropdown = true)" @mouseleave="!isMobile && (showCasesDropdown = false)" @click="isMobile && (showCasesDropdown = !showCasesDropdown)">
              <router-link to="/cases">研发案例
                <svg class="dropdown-arrow" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 9l6 6 6-6"/>
                </svg>
              </router-link>
              <transition name="dropdown">
                <ul v-show="showCasesDropdown" class="dropdown-menu">
                  <li><router-link to="/cases#rd">研发案例</router-link></li>
                  <li><router-link to="/cases#engineering">工程案例</router-link></li>
                </ul>
              </transition>
            </li>
            <li class="dropdown" :class="{ active: $route.path === '/technology' }" @mouseenter="!isMobile && (showRDDevelopmentDropdown = true)" @mouseleave="!isMobile && (showRDDevelopmentDropdown = false)" @click="isMobile && (showRDDevelopmentDropdown = !showRDDevelopmentDropdown)">
              <router-link to="/technology">科技研发
                <svg class="dropdown-arrow" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 9l6 6 6-6"/>
                </svg>
              </router-link>
              <transition name="dropdown">
                <ul v-show="showRDDevelopmentDropdown" class="dropdown-menu">
                  <li><router-link to="/technology#rnd-team">研发团队</router-link></li>
                  <li><router-link to="/technology#factory-show">工厂展示</router-link></li>
                  <li><router-link to="/technology#employment-base">就业基地</router-link></li>
                </ul>
              </transition>
            </li>
            <li class="dropdown" :class="{ active: $route.path === '/news' }" @mouseenter="!isMobile && (showNewsDropdown = true)" @mouseleave="!isMobile && (showNewsDropdown = false)" @click="isMobile && (showNewsDropdown = !showNewsDropdown)">
              <router-link to="/news">新闻动态
                <svg class="dropdown-arrow" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 9l6 6 6-6"/>
                </svg>
              </router-link>
              <transition name="dropdown">
                <ul v-show="showNewsDropdown" class="dropdown-menu">
                  <li><router-link to="/news?tab=industry">行业资讯</router-link></li>
                  <li><router-link to="/news?tab=company">公司新闻</router-link></li>
                  
                </ul>
              </transition>
            </li>
            <li class="dropdown" :class="{ active: $route.path === '/contact' }" @mouseenter="!isMobile && (showContactDropdown = true)" @mouseleave="!isMobile && (showContactDropdown = false)" @click="isMobile && (showContactDropdown = !showContactDropdown)">
              <router-link to="/contact">联系我们
                <svg class="dropdown-arrow" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 9l6 6 6-6"/>
                </svg>
              </router-link>
              <transition name="dropdown">
                <ul v-show="showContactDropdown" class="dropdown-menu">
                  <li><router-link to="/contact#join-us">加入我们</router-link></li>
                  <li><router-link to="/contact#contact-info">联系信息</router-link></li>
                  <li><router-link to="/contact#online-message">在线留言</router-link></li>
                </ul>
              </transition>
            </li>
            <li class="search-item">
              <svg @click="toggleSearch" class="search-icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"/>
                <path d="m21 21-4.35-4.35"/>
              </svg>
              <transition name="slide">
                <input v-show="showSearch" v-model="searchKeyword" @keyup.enter="handleSearch" @blur="hideSearch" class="search-input" type="text" placeholder="搜索...">
              </transition>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      showSearch: false,
      searchKeyword: "",
      // -------1125-------
      showMobileMenu: false,
      isMobile: false,
      // -------1125-------
      showHomeDropdown: false,
      showAboutDropdown: false,
      showProductsDropdown: false,
      showCasesDropdown: false,
      showRDDevelopmentDropdown: false,
      showNewsDropdown: false,
      showContactDropdown: false,
    };
  },
  created() {
    // -------1125-------
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  // -------1125-------
  destroyed() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    // -------1125-------
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
      if (!this.isMobile) {
        this.showMobileMenu = false;
      }
    },
    // -------1125-------
    toggleSearch() {
      this.showSearch = !this.showSearch;
      if (this.showSearch) {
        this.$nextTick(() => {
          this.$el.querySelector(".search-input").focus();
        });
      }
    },
    hideSearch() {
      this.showSearch = false;
      this.searchKeyword = "";
    },
    handleSearch() {
      if (this.searchKeyword.trim()) {
        console.log("搜索关键词:", this.searchKeyword);
        this.hideSearch();
      }
    },
  },
  
};
</script>

<style scoped>
@media (max-width: 768px) {
  .container{
    width: 90vw !important;
  }
}

.header-box {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  padding: 0 20px;
}
.logo img{
  width: 100%;
  height: auto;
}
.nav>ul {
  display: flex;
  list-style: none;
  margin: 3rem 0;
  padding: 0;
  gap: 3vw;
  align-items: center;
  font-size: 18px;
}
@media (max-width: 1360px) {
  .nav>ul  {
    gap: 1.5vw;
  }
}

.search-item {
  display: flex;
  align-items: center;
  gap: 0.5vw;
  position: relative;
}
.search-icon {
  cursor: pointer;
  color: azure;
  transition: color 0.3s;
}
.search-input {
  width: 140px;
  height: 23px;
  padding: 0 8px;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 4px;
  background: rgba(255,255,255,0.1);
  color: azure;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
}
.search-input::placeholder {
  color: rgba(255,255,255,0.6);
}
.search-input:focus {
  background: rgba(255,255,255,0.15);
}
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter, .slide-leave-to {
  opacity: 0;
  transform: translateX(10px);
}

/* 下拉菜单样式 */
.dropdown {
  position: relative;
}
.dropdown-arrow {
  display: inline-block;
  margin-left: 4px;
  vertical-align: middle;
  transition: transform 0.3s ease;
}
@media (max-width: 1360px) {
  .dropdown-arrow {
    margin-left: 0px;
  }
}
.dropdown:hover .dropdown-arrow {
  transform: rotate(180deg);
}
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  /* background: rgba(30, 58, 95, 0.95); */
  padding: 8px 0;
  min-width: 178px;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  backdrop-filter: blur(10px);
}
.dropdown-menu li {
  margin: 0;
  padding: 0;
  width: 100%;
}
.dropdown-menu li a {
  display: block;
  padding: 10px 20px;
  color: #ffffff;
  text-decoration: none;
  font-size: 15px;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;
}
.dropdown-menu li a:hover {
  background-color: rgba(255,255,255,0.15);
  border-left-color: #42b983;
  padding-left: 15px;
}

/* 当前选中导航加粗 */
.dropdown.active > a {
  font-weight: bold;
}

/* 下拉菜单动画 */
.dropdown-enter-active, .dropdown-leave-active {
  transition: all 0.3s ease;
}
.dropdown-enter, .dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
/*  -------1125------- */
/* 移动端样式 */
.mobile-menu-btn {
  display: none;
  cursor: pointer;
  color: #ffffff;
}

@media (max-width: 768px) {
  .search-item {
    display: none;
  }
  .mobile-menu-btn {
    display: block;
  }
  .header {
    padding: 10px 15px;
  }
  .logo img {
    width: 120px;
  }
  .nav {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: rgba(30, 58, 95, 0.95);
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
  }
  .nav.mobile-open {
    max-height: 500px;
  }
  .nav > ul {
    flex-direction: column;
    padding: 10px 35px;
    margin: 0;
  }
  .nav > ul > li {
    width: 100%;
    padding: 5px 15px;
    text-align: left;
  }
  .dropdown-menu {
    position: static;
    transform: none;
    background: transparent;
    box-shadow: none;
    padding-left: 15px;
  }
  .search-item {
    justify-content: flex-start;
    padding: 10px 15px;
  }
  /* 移动端隐藏下拉箭头SVG */
  .dropdown-arrow {
    display: none;
  }
}
/*  -------1125------- */
</style>
<!-- <style src="../assets/index.css" scoped></style> -->